/* tslint:disable */
/* eslint-disable */
/* @relayHash 79befd5820ac0c602b2e88909b551605 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ClassroomWorksheetsInfiniteScrollQueryVariables = {
    classroomId: string;
    count: number;
    cursor?: string | null;
};
export type ClassroomWorksheetsInfiniteScrollQueryResponse = {
    readonly classroom: {
        readonly " $fragmentRefs": FragmentRefs<"ClassroomWorksheetsInfiniteScroll_classroom">;
    } | null;
};
export type ClassroomWorksheetsInfiniteScrollQuery = {
    readonly response: ClassroomWorksheetsInfiniteScrollQueryResponse;
    readonly variables: ClassroomWorksheetsInfiniteScrollQueryVariables;
};



/*
query ClassroomWorksheetsInfiniteScrollQuery(
  $classroomId: ID!
  $count: Int!
  $cursor: String
) {
  classroom: node(id: $classroomId) {
    __typename
    ... on Classroom {
      ...ClassroomWorksheetsInfiniteScroll_classroom_1G22uz
    }
    id
  }
}

fragment ClassroomWorksheet_classroomWorksheet on ClassroomWorksheet {
  id
  worksheet {
    ...Worksheet_worksheet
    id
  }
  classroom {
    id
  }
}

fragment ClassroomWorksheetsInfiniteScroll_classroom_1G22uz on Classroom {
  id
  classroomWorksheets(first: $count, after: $cursor) {
    edges {
      node {
        id
        ...ClassroomWorksheet_classroomWorksheet
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment Worksheet_worksheet on Worksheet {
  title
  description
  identifier
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "classroomId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "classroomId"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ClassroomWorksheetsInfiniteScrollQuery",
    "type": "Root",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "classroom",
        "name": "node",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "type": "Classroom",
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "ClassroomWorksheetsInfiniteScroll_classroom",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "count",
                    "variableName": "count"
                  },
                  {
                    "kind": "Variable",
                    "name": "cursor",
                    "variableName": "cursor"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ClassroomWorksheetsInfiniteScrollQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "classroom",
        "name": "node",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "type": "Classroom",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "classroomWorksheets",
                "storageKey": null,
                "args": (v4/*: any*/),
                "concreteType": "ClassroomWorksheetConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ClassroomWorksheetEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ClassroomWorksheet",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "worksheet",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Worksheet",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "title",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "description",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "identifier",
                                "args": null,
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "classroom",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Classroom",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/)
                            ]
                          },
                          (v2/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "cursor",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "pageInfo",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "endCursor",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "hasNextPage",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedHandle",
                "alias": null,
                "name": "classroomWorksheets",
                "args": (v4/*: any*/),
                "handle": "connection",
                "key": "ClassroomWorksheetsInfiniteScroll_classroomWorksheets",
                "filters": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "ClassroomWorksheetsInfiniteScrollQuery",
    "id": null,
    "text": "query ClassroomWorksheetsInfiniteScrollQuery(\n  $classroomId: ID!\n  $count: Int!\n  $cursor: String\n) {\n  classroom: node(id: $classroomId) {\n    __typename\n    ... on Classroom {\n      ...ClassroomWorksheetsInfiniteScroll_classroom_1G22uz\n    }\n    id\n  }\n}\n\nfragment ClassroomWorksheet_classroomWorksheet on ClassroomWorksheet {\n  id\n  worksheet {\n    ...Worksheet_worksheet\n    id\n  }\n  classroom {\n    id\n  }\n}\n\nfragment ClassroomWorksheetsInfiniteScroll_classroom_1G22uz on Classroom {\n  id\n  classroomWorksheets(first: $count, after: $cursor) {\n    edges {\n      node {\n        id\n        ...ClassroomWorksheet_classroomWorksheet\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment Worksheet_worksheet on Worksheet {\n  title\n  description\n  identifier\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '9f7e58ac0a223d40d171b67aaf06db1b';
export default node;
